"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const index_1 = __importStar(require("@orionhealth/application-container/build/index"));
const qs_1 = __importDefault(require("qs"));
var AppContainer;
(function (AppContainer) {
    class ExternalHost extends react_1.PureComponent {
        constructor(props) {
            super(props);
            this.request = props.request;
            this.state = {
                isLoading: true
            };
        }
        componentDidMount() {
            const messageHandler = (event) => {
                // FIXME the wildcards in these postMessage calls are bad practice
                if (event.data.componentHostBootstrapConfig) {
                    let parsedBootstrapConfig = Object.assign({}, event.data.componentHostBootstrapConfig);
                    if (parsedBootstrapConfig.componentMetadata.componentConfig) {
                        parsedBootstrapConfig.componentMetadata.componentConfig = JSON.parse(parsedBootstrapConfig.componentMetadata.componentConfig);
                    }
                    this.componentHostBootstrapConfig = parsedBootstrapConfig;
                    // Set the ConcertoLocale cookie to the preferred locale
                    document.cookie = `ConcertoLocale=${this.componentHostBootstrapConfig.preferredLocale}; Path=/; Secure; SameSite=Strict`;
                    // Use the componentQueryParams to set the query string
                    if (this.componentHostBootstrapConfig.componentQueryParams) {
                        const queryString = qs_1.default.stringify(JSON.parse(this.componentHostBootstrapConfig.componentQueryParams), {
                            arrayFormat: 'repeat',
                            allowDots: true
                        });
                        const newURL = `${new URL(window.location.pathname, window.location.origin).href}?${queryString}${window.location.hash}`;
                        window.history.replaceState({
                            path: newURL
                        }, '', newURL);
                    }
                    if (this.componentHostBootstrapConfig.includeConcertoJS) {
                        window.parent.postMessage('getConcertoJSAbsolutePath', '*');
                    }
                    else {
                        window.parent.postMessage('getComponentHostKeepalivePingAbsolutePath', '*');
                    }
                }
                else if (event.data.concertoJSAbsolutePath) {
                    this.concertoJSAbsolutePath = event.data.concertoJSAbsolutePath;
                    window.parent.postMessage('getComponentHostKeepalivePingAbsolutePath', '*');
                }
                else if (event.data.componentHostKeepAlivePingAbsolutePath) {
                    this.componentHostKeepAlivePingAbsolutePath = event.data.componentHostKeepAlivePingAbsolutePath;
                    this.setState({
                        isLoading: false
                    });
                }
            };
            window.addEventListener("message", messageHandler);
            window.parent.postMessage('getComponentHostBootstrapConfig', '*');
        }
        render() {
            const { isLoading } = this.state;
            if (isLoading) {
                return react_1.default.createElement("p", null, "Loading...");
            }
            else if ((this.componentHostBootstrapConfig.includeConcertoJS && !this.concertoJSAbsolutePath) || !this.componentHostKeepAlivePingAbsolutePath || !this.componentHostBootstrapConfig) {
                throw new Error('Loading should not be finished before external host has bootstrapped fully.');
            }
            const { moduleMeta, moduleImport } = this.props;
            moduleMeta.componentConfig = Object.assign({}, moduleMeta.componentConfig, this.componentHostBootstrapConfig.componentMetadata.componentConfig);
            const applicationContainerProps = {
                componentContext: this.componentHostBootstrapConfig.componentContext,
                request: this.request,
                moduleMeta,
                onSubrouteChange: () => { },
                subroute: '/',
                /**
                 * We expect the UI elements that application container needs
                 * to be passed in as props. This functions must return React
                 * Components for a loading spinner and an errorPage, or null.
                 *
                 * We must preserve the no *UI* contract in Shell to avoid
                 * a hard dependency on a React DOM impl which will limit
                 * the usage of Shell.
                 */
                renderSpinner: () => react_1.default.createElement("div", null, "Loading..."),
                renderErrorMessage: () => react_1.default.createElement("div", null, "Error rendering component."),
                render404: () => react_1.default.createElement("div", null, "404 Not Found"),
                modules: {
                    [moduleMeta.moduleName]: {
                        [moduleMeta.moduleVersion]: react_1.lazy(() => moduleImport().then(index_1.host('Component')))
                    }
                },
                // Determines whether the SystemJS fallback option should be used
                // In order to maintain backwards compatibility, this defaults to
                // true, but that will change in the next major revision.
                enableSystemJS: false
            };
            return react_1.default.createElement(index_1.default, Object.assign({}, applicationContainerProps));
        }
    }
    AppContainer.ExternalHost = ExternalHost;
})(AppContainer = exports.AppContainer || (exports.AppContainer = {}));
//# sourceMappingURL=AppContainer.js.map